import type { BookingPreference } from '../../domain/types'
import type { BookingPreferencesPayload } from '../types'

export function bookingPreferencesPayloadMapper(preferences: BookingPreference[]): BookingPreferencesPayload {
  return {
    preferences: preferences
      .filter(preference => preference.isSelected)
      .map((preference) => {
        const customerInput = preference.customerInput.trim()

        if (preference.type !== 'CustomerInput' || customerInput === '') {
          return { id: preference.id }
        }

        return { id: preference.id, customerInput }
      }),
  }
}
